import axios from "axios";

import Config from "src/config";

const v2_actionAtualizarCampanhaRastreamento = (clienteId, campanhaId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/marketing/campanhas-rastreamento/${campanhaId}`,
        data
    });
};

export default v2_actionAtualizarCampanhaRastreamento;
